import { useEffect } from 'react';
import PropTypes from 'prop-types';

import checkGrayIcon from 'assets/check-gray.svg';
import plusOutlineGrayIcon from 'assets/plus-outline-gray.svg';

import styles from 'Pages/TeamDashboard/ProductLibrary/styles.module.scss';

import { formatDate } from 'utlis/string_format';

const VersionDropdown = ({
  versions, currentVersion, containerRef, onClose, onAddVersion, onVersionSelect, showAddVersion = true,
}) => {
  useEffect(() => {
    const handleMouseDown = e => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleMouseDown);

    return () => document.removeEventListener('mousedown', handleMouseDown);
  }, [onClose, containerRef]);

  return (
    <div className={styles.versionDropdown}>
      <div className={styles.versionSection}>
        <span className={styles.versionHeading}>
          Versions
        </span>
        {versions.map(version => (
          <button
            key={version.version_number}
            type="button"
            className={`${styles.versionItem}
            ${version.version_number === currentVersion ? styles.versionItemSelected : ''}`}
            onClick={() => onVersionSelect(version.version_number)}
          >
            {version.version_number === currentVersion
              ? (
                <img src={checkGrayIcon} alt="" className={styles.versionCheckmark} />
              )
              : (
                <div className={styles.versionCheckmark} />
              )}
            <div className={styles.versionLabel}>
              <span className={styles.versionNumber}>
                v
                {version.version_number}
              </span>
              <span className={styles.versionDate}>
                {formatDate(version.created_at)}
              </span>
              {version.version_number === currentVersion && (
                <span className={styles.versionBadge}>
                  Current
                </span>
              )}
            </div>
          </button>
        ))}
      </div>

      {showAddVersion && (
        <>
          <hr className={styles.versionDivider} />

          <button className={styles.addVersionBtn} onClick={onAddVersion}>
            <img src={plusOutlineGrayIcon} alt="" width={16} height={16} />
            <span>
              Add new version
            </span>
          </button>
        </>
      )}
    </div>
  );
};

VersionDropdown.propTypes = {
  versions: PropTypes.arrayOf(
    PropTypes.shape({
      version_number: PropTypes.number.isRequired,
      created_at: PropTypes.string.isRequired,
      is_current: PropTypes.bool.isRequired,
    })
  ).isRequired,
  currentVersion: PropTypes.number.isRequired,
  containerRef: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onAddVersion: PropTypes.func,
  onVersionSelect: PropTypes.func.isRequired,
  showAddVersion: PropTypes.bool,
};

export default VersionDropdown;
